import { render, staticRenderFns } from "./lyricsTimeline.vue?vue&type=template&id=45a0e7be&scoped=true"
import script from "./lyricsTimeline.vue?vue&type=script&lang=js"
export * from "./lyricsTimeline.vue?vue&type=script&lang=js"
import style0 from "./lyricsTimeline.vue?vue&type=style&index=0&id=45a0e7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a0e7be",
  null
  
)

export default component.exports